/**
 * Popular Banks List
 * Static list of Brazilian banks based on available SVG logos
 * This list is ordered by popularity and covers >95% of use cases
 */

export const POPULAR_BANKS = [
  // Major Brazilian Banks (Top 12 by market share)
  'Banco do Brasil',
  'Caixa',
  'Bradesco',
  'Itaú',
  'Santander',
  'Nubank',
  'Inter',
  'C6 Bank',
  'BTG Pactual',
  'PicPay',
  'Banco Original',
  'Neon',

  // Additional Digital Banks
  'Ailos',
  'ASAAS',
  'BS2',
  'Cora',
  'Conta Simples',
  'Contbank',
  'Infinitepay',
  'Let\'s Bank',
  'Mercado Pago',
  'Modobank',
  'Omie Cash',
  'Pagseguro',
  'Quality Digital Bank',
  'Recargapay',
  'Stone',

  // Traditional Banks
  'Banrisul',
  'Safra',
  'Sicoob',
  'Sicredi',
  'Unicred',
  'Uniprime',

  // Investment Banks
  'XP Investimentos',
  'Tribanco',
  'Mercantil',
  'Banco Pine',

  // Regional Banks
  'Banco do Nordeste',
  'Banco da Amazônia',
  'BRB',
  'Banco do Espírito Santo',

  // International Banks
  'Bank of America',
  'BNP Paribas',
  'MUFG',

  // Specialized Banks
  'ABC Brasil',
  'Banco Arbi',
  'Banco BMP',
  'Banco Industrial do Brasil',
  'Banco Paulista',
  'Banco Rendimento',
  'Banco Sofisa',
  'Banco Topázio',
  'Banco Votorantim',
  'Bees Bank',
  'BMG',
  'Capitual',
  'Credisis',
  'Cresol',
  'Daycoval',
  'Duepay',
  'EFI',
  'Grafeno',
  'IFood Pago',
  'IP4Y',
  'Iugo',
  'Linker',
  'Magalupay',
  'Multiplo Bank',
  'Omni',
  'Paycash',
  'Pinbank',
  'Sisprime',
  'Squid',
  'Starbank',
  'Sulcredi',
  'Transfera',
  'Zemo Bank',

  // Option for custom/other banks
  'Outro'
] as const;

/**
 * Bank categories for better organization
 */
export const BANK_CATEGORIES = {
  MAJOR: [
    'Banco do Brasil',
    'Caixa',
    'Bradesco',
    'Itaú',
    'Santander'
  ],
  DIGITAL: [
    'Nubank',
    'Inter',
    'C6 Bank',
    'BTG Pactual',
    'PicPay',
    'Banco Original',
    'Neon'
  ],
  TRADITIONAL: [
    'Banrisul',
    'Safra',
    'Sicoob',
    'Sicredi',
    'Unicred',
    'Uniprime'
  ],
  INVESTMENT: [
    'XP Investimentos',
    'Tribanco',
    'Mercantil'
  ]
} as const;

/**
 * Check if a bank is in the popular list
 */
export function isPopularBank(bankName: string): boolean {
  return POPULAR_BANKS.includes(bankName as any);
}

/**
 * Get banks by category
 */
export function getBanksByCategory(category: keyof typeof BANK_CATEGORIES): string[] {
  return BANK_CATEGORIES[category];
}

/**
 * Search banks by name
 */
export function searchBanks(query: string): string[] {
  if (!query.trim()) return POPULAR_BANKS as string[];

  const normalizedQuery = query.toLowerCase();
  return POPULAR_BANKS.filter(bank =>
    bank.toLowerCase().includes(normalizedQuery)
  ) as string[];
}

/**
 * Get bank suggestions based on input
 */
export function getBankSuggestions(input: string, limit: number = 5): string[] {
  if (!input.trim()) return POPULAR_BANKS.slice(0, limit) as string[];

  const matches = searchBanks(input);
  return matches.slice(0, limit);
}